
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from './Button';
import { Send, Twitter, Instagram, Lock, Building, Megaphone, Users } from 'lucide-react';
import { COMPANY_INFO, EXTERNAL_LINKS } from '../../constants';

export const SocialEcosystem: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-[#151E32] border border-gray-800 rounded-3xl p-8 mb-12">
       <div className="flex items-center justify-center mb-8">
          <Send className="text-blue-500 mr-3" size={32} />
          <h3 className="text-2xl font-bold text-white">{t('socialSection.telegramTitle')}</h3>
       </div>
       <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">{t('socialSection.telegramDesc')}</p>
       
       <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Corporate Group */}
          <div className="bg-[#0f1623] border border-gray-700 rounded-2xl p-6 flex flex-col relative overflow-hidden group hover:border-blue-500 transition-colors">
             <div className="absolute top-0 right-0 p-4">
                <Lock size={16} className="text-gray-500" />
             </div>
             <div className="w-12 h-12 bg-blue-900/20 rounded-full flex items-center justify-center mb-4 text-blue-400">
                <Building size={24} />
             </div>
             <h4 className="text-lg font-bold text-white mb-2">{t('socialSection.telegramChannels.corporate.title')}</h4>
             <p className="text-sm text-gray-400 mb-6 flex-grow leading-relaxed">
                {t('socialSection.telegramChannels.corporate.desc')}
             </p>
             <a href={EXTERNAL_LINKS.TELEGRAM_ACCESS} target="_blank" rel="noopener noreferrer">
                <Button className="w-full bg-blue-600 hover:bg-blue-500 text-white text-sm">
                   {t('socialSection.telegramChannels.corporate.action')}
                </Button>
             </a>
          </div>

          {/* Token Channel */}
          <div className="bg-[#0f1623] border border-gray-700 rounded-2xl p-6 flex flex-col relative overflow-hidden group hover:border-orange-500 transition-colors">
             <div className="w-12 h-12 bg-orange-900/20 rounded-full flex items-center justify-center mb-4 text-orange-500">
                <Megaphone size={24} />
             </div>
             <h4 className="text-lg font-bold text-white mb-2">{t('socialSection.telegramChannels.token.title')}</h4>
             <p className="text-sm text-gray-400 mb-6 flex-grow leading-relaxed">
                {t('socialSection.telegramChannels.token.desc')}
             </p>
             <a href={EXTERNAL_LINKS.TELEGRAM_TOKEN_CHANNEL} target="_blank" rel="noopener noreferrer">
                <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white text-sm border-0">
                   {t('socialSection.telegramChannels.token.action')}
                </Button>
             </a>
          </div>

          {/* Community */}
          <div className="bg-[#0f1623] border border-gray-700 rounded-2xl p-6 flex flex-col relative overflow-hidden group hover:border-green-500 transition-colors">
             <div className="w-12 h-12 bg-green-900/20 rounded-full flex items-center justify-center mb-4 text-green-500">
                <Users size={24} />
             </div>
             <h4 className="text-lg font-bold text-white mb-2">{t('socialSection.telegramChannels.community.title')}</h4>
             <p className="text-sm text-gray-400 mb-6 flex-grow leading-relaxed">
                {t('socialSection.telegramChannels.community.desc')}
             </p>
             <a href={EXTERNAL_LINKS.TELEGRAM_TOKEN_COMMUNITY} target="_blank" rel="noopener noreferrer">
                <Button className="w-full bg-green-600 hover:bg-green-500 text-white text-sm border-0">
                   {t('socialSection.telegramChannels.community.action')}
                </Button>
             </a>
          </div>
       </div>

       {/* Other Socials */}
       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {/* Twitter */}
          <a href={COMPANY_INFO.social.twitter} target="_blank" rel="noopener noreferrer" className="bg-[#0f1623] border border-gray-700 rounded-2xl p-8 flex items-center hover:border-white transition-all group">
             <div className="w-16 h-16 bg-[#151E32] rounded-full flex items-center justify-center mr-6 border border-gray-600 group-hover:bg-white group-hover:text-black transition-colors">
                <Twitter size={28} />
             </div>
             <div>
                <h3 className="text-xl font-bold text-white mb-2">{t('socialSection.twitter')}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{t('socialSection.twitterDesc')}</p>
             </div>
          </a>

          {/* Instagram */}
          <a href={COMPANY_INFO.social.instagram} target="_blank" rel="noopener noreferrer" className="bg-[#0f1623] border border-gray-700 rounded-2xl p-8 flex items-center hover:border-pink-500 transition-all group">
             <div className="w-16 h-16 bg-[#151E32] rounded-full flex items-center justify-center mr-6 border border-gray-600 group-hover:bg-gradient-to-tr group-hover:from-yellow-400 group-hover:via-pink-500 group-hover:to-purple-600 group-hover:text-white transition-colors">
                <Instagram size={28} />
             </div>
             <div>
                <h3 className="text-xl font-bold text-white mb-2">{t('socialSection.instagram')}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{t('socialSection.instagramDesc')}</p>
             </div>
          </a>
       </div>
    </div>
  );
};
